module.exports = "/_next/static/resources/photo-4-b5091d7a983be9f27ef9ec2bf33827a8.webp";